<template>
<div class="bytee-quiz">
  <h3>Resources</h3>

  <h4>Scrum Master</h4>
  <ul>
    <li>
      <a href="https://www.youtube.com/watch?v=nLwISuyprwg">
      Scrum Master PSM I exam experience & tips (YouTube)</a>
    </li>
  </ul>

  <h4>Product Owner</h4>
  <ul>
    <li>
      <a href="https://www.youtube.com/watch?v=8a7kj6b8R_U">
      Product Owner PSPO I experience & tips (YouTube)</a>
    </li>
  </ul>
</div>
</template>

<script>

export default {
  name: 'resources',
  components: {},
};
</script>

<style>
</style>
